import {
  ConsolidatedPaymentFormItem,
  ConsolidatedToPayItem,
  ConsolidatedToPayquest,
} from "@/types/financials/ConsolidatedPayment";
import { SummaryStatementFormItem } from "@/types/financials/SummaryStatement";

export const defaultSummaryStatementFormItem =
  (): SummaryStatementFormItem => ({
    startDate: "",
    endDate: "",
    bankAccountId: 0,
    contactType: -1,
    specialContactId: 0,
    statmentCount: 0,
    productId: 0,
    debitAmount: 0,
    statementNotes: "",
    statementsFilings: 0,
    statementsPostings: 0,
    statementsEmails: 0,
    enableButRun: false,
    enableButPrintForFiling: false,
    enableButPrintForPosting: false,
    enableButEmail: false,
    enableGrpCharge: true,
    enableGrpContacts: true,
  });

export const defaultConsolidatedPaymentFormItem =
  (): ConsolidatedPaymentFormItem => ({
    contactId: 0,
    bankAccountId: -1,
    bankAccountName: "",
    siteId: 0,
    onlyIncludeWithBankAccounts: false,
    paymentExportFormat: 0,
    paymentMethodId: 0,
    paymentDate: "",
    processingDate: "",
    statementsFiling: 0,
    statementsPosting: 0,
    statementsEmail: 0,
    preferredDeliveryMethod: true,
    enableButPrintForFiling: false,
    enableButPrintForPosting: false,
    enableButPaymentExportFile: false,
    enablePreferredDeliveryMethod: false,
    enableButEmail: false,
    butMenuEnabled: true,
    butRunEnabled: false,
    paymentSummaryReportAvailable: true,
    landlordEnable: true,
    paymentMethodEnable: true,
    paymentDateEnable: true,
    chkBankAccountEnable: true,
    creditsEnable: true,
    siteEnable: true,
    bankAccountEnable: true,
    paymentExportFormatEnable: true,
    butExitEnabled: true,
    paymentRunId: 0,
    accountStatements: [],
    paymentRunExportFileName: "",
    allowUnclearedFundsPayments: -1,
  });

export const defaultConsolidatedToPayItem = (): ConsolidatedToPayItem => ({
  id: 0,
  contactId: 0,
  contact: "",
  preferredPaymentDay: "",
  lastPaymentDate: "",
  rentArrears: 0,
  warnings: "",
  referenceChequeNo: "",
  balance: 0,
  consolidatedFloat: 0,
  taxToDeduct: 0,
  invoiceFeesSeparately: false,
  invoiceFeesTotal: 0,
  amountToPay: 0,
  pausePaymentRun: false,
  disableUnclearedFunds: 0,
  include: false,
  disableInclude: false,
});

export const defaultConsolidatedToPayquest = (): ConsolidatedToPayquest => ({
  contactId: 0,
  bankAccountId: -1,
  siteId: -1,
  onlyIncludeWithBankAccounts: false,
  paymentExportFormat: -1,
});

export const FinancialDefaults = {
  defaultConsolidatedToPayquest: defaultConsolidatedToPayquest,
  defaultConsolidatedToPayItem: defaultConsolidatedToPayItem,
  defaultConsolidatedPaymentFormItem: defaultConsolidatedPaymentFormItem,
  defaultSummaryStatementFormItem: defaultSummaryStatementFormItem,
};
